import './Questions.sass';

import React from 'react';
import { browserHistory } from 'react-router';

import ChapterDefinitions from '../../../commonComponents/Modals/ChapterDefinitions/ChapterDefinitions';
import Spinner from '../../../commonComponents/Spinner/Spinner';
import { infinitePageSize } from '../../../constants/pagination';
import { canPerformAction } from '../../../utilities/permissionUtils';
import ChangeHistoryContainer from '../../ChangeHistoryContainer/components/ChangeHistoryContainer';
import Footer from '../commonComponents/Footer/Footer';
import Header from '../commonComponents/Header/HeaderContainer';
import QuestionGrid from './QuestionGrid/QuestionGrid';
import QuestionListView from './QuestionListView/QuestionListView';
import QuestionPDFView from './QuestionPDFView/QuestionPDFView';

export default class Questions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      question: null,
      selectedRate: { id: 0 },
      historyObject: {},
      hasTosetQuestion: false,
      scrolled: false,
      questionToSet: null,
    };

    this.backListener = browserHistory.listen((location) => {
      if (location.action === 'POP') {
        this.onBrowserBack();
      }
    });
  }

  componentWillMount() {
    if (
      !this.props.assignment &&
      this.props.params?.reference &&
      this.props.params.chapter
    ) {
      this.props.loadChapter(this.props.params.chapter);
      this.props.loadReference(this.props.params.reference);

      if (this.props.location.query.questionid) {
        this.setState({
          hasTosetQuestion: true,
          questionToSet: this.props.location.query.questionid,
        });
      }
    }

    if (this.props.assignment?.chapter) {
      this.props.loadChapter(this.props.assignment.chapter.id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.chapter &&
      !this.props.chapter.reference &&
      !this.props.reference.id &&
      nextProps.chapter.reference
    ) {
      this.props.loadReference(nextProps.chapter.reference);
    }
    if (
      nextProps.chapter?.reference &&
      nextProps.editPermission === null &&
      nextProps.permissions
    ) {
      this.hasEditQuestionPermission(nextProps);
    }
  }

  componentDidUpdate() {
    if (
      this.state.hasTosetQuestion &&
      !this.state.scrolled &&
      !this.props.isLoadingQuestions
    ) {
      const questionListContainer = document.querySelector(
        '.questionListContainer',
      );
      let scrollView = null;
      if (questionListContainer) {
        scrollView = questionListContainer.childNodes[0];
      }
      const questionElement = window.jQuery(
        `#question-list-id-${this.state.questionToSet}`,
      );
      if (questionListContainer && scrollView && questionElement) {
        const position = window
          .jQuery(`#question-list-id-${this.state.questionToSet}`)
          .position();
        if (position) {
          scrollView.scrollTop = position.top - scrollView.clientHeight * 0.5;
          questionElement.click();
          this.setState({ scrolled: true });
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.setEditPermission(null);
    this.props.onViewChange('listView');
    this.props.onClearQuestions();
    this.props.clearReference();
    this.props.clearChapter();
    this.props.setIsViewDeletedQuestions(false);
    this.backListener();
  }

  componentDidMount() {
    const pathname = window.location.pathname;
    const { permissions } = this.props;

    if (pathname.includes('/mission-control/assignments')) {
      if (
        !canPerformAction('MissionControl.Assignments.Questions', permissions)
      ) {
        browserHistory.replace('/401');
        return;
      }
    } else if (pathname.includes('/mission-control/writers')) {
      if (!canPerformAction('MissionControl.Writers.Questions', permissions)) {
        browserHistory.replace('/401');
        return;
      }
    }

    if (this.props.location?.state) {
      const historyObject = this.props.location.state.historyObject;
      const rate =
        this.props.location.state.selectedRate || this.props.selectedRate;
      this.setState({ selectedRate: rate, historyObject, rate });
    } else {
      this.setState({
        selectedRate: this.props.selectedRate,
        rate: this.props.selectedRate,
      });
    }
    if (this.props.location?.query?.question) {
      this.props.setUrlQuestion(this.props.location.query.question);
    }
  }

  renderContent = (view, isWaiting, isUpdating) => {
    if ((isWaiting && !isUpdating) || !this.props?.chapter?.id) {
      return (
        <div className="centerSpinner">
          <Spinner text="Loading questions" />
        </div>
      );
    }
    switch (view) {
      case 'pdfView':
        return (
          <QuestionPDFView
            {...this.props}
            permissionPrefix={this.getPermissionPrefix()}
          />
        );
      case 'gridView':
        return (
          <QuestionGrid
            {...this.props}
            openHistoryView={this.openHistoryView}
            permissionPrefix={this.getPermissionPrefix()}
          />
        );
      default:
        return (
          <QuestionListView
            {...this.props}
            permissionPrefix={this.getPermissionPrefix()}
            loadAllQuestions={!!this.state.hasTosetQuestion}
          />
        );
    }
  };

  onBrowserBack = () => {
    this.props.onBack(this.props.assignment, this.state);
  };

  openQuestionsModal = () => {
    this.props.openModal({
      modalClassName: 'modal-question-definitions',
      modalContent: (
        <ChapterDefinitions
          reference={
            this.props.assignment
              ? this.props.assignment.chapter.reference
              : this.props.reference
          }
          question={this.props.selectedQuestion}
          closeModal={this.props.closeModal}
          assignment={this.props.assignment}
        />
      ),
    });
  };

  openHistoryView = (question) => {
    this.setState({ question, isInViewHistory: true });
  };

  onHistoryBack = () => {
    this.setState({ isInViewHistory: false });
  };

  toggleDeletedQuestions = () => {
    const {
      isShowDeletedQuestions,
      setIsViewDeletedQuestions,
      onClearQuestions,
      loadQuestionsOfChapter,
      params,
      assignment,
    } = this.props;
    setIsViewDeletedQuestions(!isShowDeletedQuestions);
    onClearQuestions();
    loadQuestionsOfChapter(
      assignment?.id ? assignment.chapter.id : params.chapter,
      1,
      infinitePageSize,
      assignment?.id ?? null,
      null,
      undefined,
      !isShowDeletedQuestions,
    );
  };

  getPermissionPrefix = () => {
    const pathname = window.location.pathname;

    if (pathname.includes('/mission-control/writers')) {
      return 'MissionControl.Writers.Questions';
    }

    // Default: direct Books access
    return 'Books.Questions';
  };

  hasEditQuestionPermission = (props) => {
    const { permissions } = props;
    const permissionPrefix = this.getPermissionPrefix();
    const hasPermission = canPerformAction(
      `${permissionPrefix}.Manage`,
      permissions,
    );
    this.props.setEditPermission(hasPermission);
  };

  restrictChapterFurtherReading = () => {
    if (this.props.chapter?.id) {
      this.props.restrictChapterFurtherReading(this.props.chapter.id);
    }
  };

  render() {
    return this.state.isInViewHistory ? (
      <ChangeHistoryContainer
        question={this.state.question}
        assignment={this.props.assignment.id}
        onBack={this.onHistoryBack}
      />
    ) : (
      <div
        style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
      >
        <Header
          {...this.props}
          permissionPrefix={this.getPermissionPrefix()}
          onShowDefinitions={this.openQuestionsModal}
          onHeaderBack={(state) =>
            this.props.onBack(
              this.props.assignment,
              state,
              this.props.writers,
              this.props.location,
            )
          }
          selectedRate={this.state.selectedRate}
          rate={this.state.rate}
          historyObject={this.state.historyObject}
          isQual={this.props.params?.isQual === 'true'}
          toggleDeletedQuestionsView={this.toggleDeletedQuestions}
          isWaiting={this.props.isWaiting}
          getQuestionsForDownload={this.props.getQuestionsForDownload}
          questionsForDeleted={this.props.questionsForDeleted}
          deleteQuestion={this.props.deleteQuestion}
          setSeletedQuestionsForDeleted={
            this.props.setSeletedQuestionsForDeleted
          }
          restoreQuestion={this.props.restoreQuestion}
          restrictChapterFurtherReading={() =>
            this.restrictChapterFurtherReading()
          }
        />
        <div style={{ flex: 1, overflow: 'auto' }}>
          {this.renderContent(
            this.props.selectedView,
            this.props.isWaiting,
            this.props.isUpdating,
          )}
        </div>
        <Footer {...this.props} permissionPrefix={this.getPermissionPrefix()} />
      </div>
    );
  }
}
